import { useQuery } from "@tanstack/react-query";
import { useToast } from "@repo/ui";
import { configurationApi } from "~/api";

const getCustomersQueryKey = () => configurationApi.queryOptions("get", "/api/Customer").queryKey;

export const useCustomers = () => {
  const { showToast } = useToast();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: getCustomersQueryKey(),
    queryFn: async () => {
      const response = await configurationApi.client.GET("/api/Customer");
      if (response.error) {
        const errorMessage = `Failed to fetch customers: ${response.error.toString()}`;
        showToast("error", "Error", errorMessage);
        throw new Error(errorMessage);
      }
      return response.data || [];
    },
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  return {
    customers: data || [],
    isLoading,
    error,
    refetch,
  };
};

export const useCustomer = (customerId: number | undefined) => {
  const { customers, isLoading, error } = useCustomers();

  const customer = customerId ? customers.find((c) => c.id === customerId) : undefined;

  return {
    customer,
    isLoading,
    error,
  };
};
